import { Link } from "react-router-dom";
import "./errors.css";

export default function NotFound() {
    return (
        <div className="error-container">
            <h1>Error 404.</h1>
            <p>
                Page not found.
            </p>
            <Link to="/">Navigate Home</Link>
        </div>
    )
}